import React, { Component } from "react";
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Button, Modal } from "antd";
import { WeaLocaleProvider, WeaShare } from 'ecCom'
const getLabel = WeaLocaleProvider.getLabel
const confirm = Modal.confirm;

@observer
export default class ItemBtns extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shareShow: false,
            sharedata:{},
        };
    }
    handleMouseOver = (itemid, attr) => {
        let { sysFavouriteStore } = this.props;
        sysFavouriteStore.setBtnOver(itemid, attr, true);
    }

    handleMouseOut = (itemid, attr) => {
        let { sysFavouriteStore } = this.props;
        sysFavouriteStore.setBtnOver(itemid, attr, false);
    }

    /**
     * 转发按钮的移入移出
     */
    onRepeatOver = () => {
        let itemid = this.props.favid;
        let attr = "isrepeatover";
        this.handleMouseOver(itemid, attr);
    }
    onRepeatOut = () => {
        let itemid = this.props.favid;
        let attr = "isrepeatover";
        this.handleMouseOut(itemid, attr);
    }
    onRepeatClick = () => {
        let dataid = this.props.favid;
        let data = toJS(this.props.sysFavouriteStore.data)
        let shareTF = ['','doc','workflow']
        let sharedata = {}
        data.map((value,index)=>{if(value.favid===dataid){
            sharedata = value
            sharedata['type'] = shareTF[Number(value.favouritetype)]
        }})
        console.log(sharedata)
        //这里遍历数据找到要的信息填充到分享页面
        this.props.sysFavouriteStore.sharedata = sharedata
        this.props.sysFavouriteStore.shareShow = true
    }

    /**
     * 编辑按钮的移入、移出、点击
     */
    onEidtOver = () => {
        let itemid = this.props.favid;
        let attr = "iseditover";
        this.handleMouseOver(itemid, attr);
    }
    onEditOut = () => {
        let itemid = this.props.favid;
        let attr = "iseditover";
        this.handleMouseOut(itemid, attr);
    }
    onEditClick = () => {
        let dataid = this.props.favid;
        let { sysFavFormStore, favouriteDialogStore } = this.props;
        sysFavFormStore.loadForm(dataid);    //加载编辑窗口的数据
        //打开编辑窗口
        favouriteDialogStore.openEditDialog();
    }

    /**
     * 移动按钮的移入、移出、点击
     */
    onMoveOver = () => {
        let itemid = this.props.favid;
        let attr = "ismoveover";
        this.handleMouseOver(itemid, attr);
    }
    onMoveOut = () => {
        let itemid = this.props.favid;
        let attr = "ismoveover";
        this.handleMouseOut(itemid, attr);
    }
    onMoveClick = () => {
        let dataid = this.props.favid;
        let { sysFavouriteStore, favouriteDialogStore, favouriteBrowserStore } = this.props;

        //设置需要移动的数据
        sysFavouriteStore.setMoveIds([dataid]);
        //先清空数据
        favouriteBrowserStore.destroyBrowser();
        //显示窗口
        favouriteDialogStore.openBrowserDialog();
        //显示加载中的遮罩
        favouriteBrowserStore.toggleSpinning(true, `${getLabel(82275, "数据加载中，请稍候...")}`);
        //加载目录树的数据
        favouriteBrowserStore.loadTreedata("0");
    }

    /**
     * 删除按钮的移入、移出、点击
     */
    onDeleteOver = () => {
        let itemid = this.props.favid;
        let attr = "isdeleteover";
        this.handleMouseOver(itemid, attr);
    }
    onDeleteOut = () => {
        let itemid = this.props.favid;
        let attr = "isdeleteover";
        this.handleMouseOut(itemid, attr);
    }
    onDeleteClick = () => {
        let itemid = this.props.favid;
        let { sysFavouriteStore } = this.props;
        confirm({
            content: `${getLabel(388215, "删除后不可恢复，您确认删除该条记录吗？")}`,
            onOk() {
                sysFavouriteStore.deleteFavourite(itemid);
            },
            onCancel() {
            }
        });
    }


    renderBtns = () => {
        let btns = [];
        let {
            favouritetype, repeatIconTitle, editIconTitle,
            moveIconTitle, deleteIconTitle,
            isrepeatover, iseditover, ismoveover, isdeleteover, forwardIconTitle, isforwardover
        } = this.props;

        let repeatCls = "";
        let editCls = "";
        let moveCls = "";
        let deleteCls = "";
        let forwardCls = "";
        if (isrepeatover) {
            repeatCls = "over";
        }
        if (iseditover) {
            editCls = "over";
        }
        if (ismoveover) {
            moveCls = "over";
        }
        if (isdeleteover) {
            deleteCls = "over";
        }


        if (favouritetype == 6) {   //消息类型，不可编辑
            // btns.push(<span className='forward' title={forwardIconTitle} onMouseOver={this.onRepeatOver}
            //     onMouseOut={this.onRepeatOut} onClick={()=>{this.onRepeatClick()}}>
            //     <a href='javascript:void(0)' className={repeatCls}></a></span>);   //转发
            btns.push(<span className='move' title={moveIconTitle} onMouseOver={this.onMoveOver}
                onMouseOut={this.onMoveOut} onClick={this.onMoveClick}>
                <a href='javascript:void(0)' className={moveCls}></a></span>);    //移动
            btns.push(<span className='delete' title={deleteIconTitle} onMouseOver={this.onDeleteOver}
                onMouseOut={this.onDeleteOut} onClick={this.onDeleteClick}>
                <a href='javascript:void(0)' className={deleteCls}></a></span>);   //删除


        } else {
            // btns.push(<span className='forward' title={forwardIconTitle} onMouseOver={this.onRepeatOver}
            //     onMouseOut={this.onRepeatOut} onClick={()=>{this.onRepeatClick()}}>
            //     <a href='javascript:void(0)' className={repeatCls}></a></span>);   //转发
            btns.push(<span className='edit' title={editIconTitle} onMouseOver={this.onEidtOver}
                onMouseOut={this.onEditOut} onClick={this.onEditClick}>
                <a href='javascript:void(0)' className={editCls}></a></span>);    //编辑
            btns.push(<span className='move' title={moveIconTitle} onMouseOver={this.onMoveOver}
                onMouseOut={this.onMoveOut} onClick={this.onMoveClick}>
                <a href='javascript:void(0)' className={moveCls}></a></span>);    //移动
            btns.push(<span className='delete' title={deleteIconTitle} onMouseOver={this.onDeleteOver}
                onMouseOut={this.onDeleteOut} onClick={this.onDeleteClick}>
                <a href='javascript:void(0)' className={deleteCls}></a></span>);   //删除

        }
        return btns;
    }


    render() {
        const btns = this.renderBtns();

        let { isover } = this.props;
        let cls = "";
        if (!isover) {   //isover为false时，鼠标移出
            cls = "hidebtns";
        }

        return (
            
                <div className={`common sysfav-list-item-info-btns ${cls}`}>
                {btns}
             
               
                </div>
    
            

        );
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/favourite/components/favourite/ItemBtns.js